/* @flow */
import qs from 'qs';
import { Container } from 'flux/utils';
import AppUpsellPage from 'user/components/AppUpsellPage';
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal';
import * as React from 'react';
import GroupStore from 'groups/stores/GroupStore';
import { mountModal } from 'lib/modal';
import { markSeenClasses } from 'utils/accountCompletionTracker';
import EventTracking from 'lib/EventTracking';

import type { RouterState } from 'lib/ReactRouterTypes';

type Props = {
  location: Object,
};

type State = {
  groupName: ?string,
};

class AppUpsellPageContainer extends React.Component<Props, State> {
  state = { groupName: null };

  // This has to be here in order to get a CurrentUser
  static onEnter(nextState: RouterState, replaceWith: Function, callback: Function) {
    AuthActions.checkLoggedIn().then(() => callback(), () => callback());
  }

  static getStores() {
    return [GroupStore];
  }

  static calculateState() {
    const group = GroupStore.getGroupCreatedDuringSetup();
    return {
      groupName: group && group.getName(),
    };
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.query && location.query.path) {
      const queryParams = qs.parse(location.query.path.split('?')[1]);
      if (location.query.path.startsWith('/v1/share')) {
        EventTracking.track('share_on_remind.mobile_web', {
          referrer: queryParams['referrer'],
          url: queryParams['url'],
        });
      }
    }
    if (!CurrentUser.isSignedIn()) {
      return;
    }
    const { path } = this.props.location.query;
    if (path && path.startsWith('/classes')) {
      markSeenClasses(CurrentUser.getUser());
    }

    const { join } = this.props.location.query;
    if (join) {
      mountModal(<JoinConfirmSubscriptionModal code={join} />, this);
    }

    AuthActions.setAutologinTokenCookie();
  }

  render() {
    return (
      <AppUpsellPage
        groupName={this.state.groupName}
        origin={this.props.location.query.origin || 'direct'}
        haveAppUrl={this.props.location.query.path}
      />
    );
  }
}
export { AppUpsellPageContainer };
export default Container.create(AppUpsellPageContainer);
